// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1682":"0d53630144978078","9651":"9f2fc892289dda5f"}[chunkId] + ".js";
};